import { render, staticRenderFns } from "./sent.vue?vue&type=template&id=0b9f762e&scoped=true&"
import script from "./sent.vue?vue&type=script&lang=js&"
export * from "./sent.vue?vue&type=script&lang=js&"
import style0 from "./sent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sent.vue?vue&type=style&index=1&id=0b9f762e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f762e",
  null
  
)

export default component.exports